import React from 'react'
import { useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { Box, Button } from '@mui/material'
import { useCurrentUserResource } from 'infrastructure/auth/auth.hooks'
import { markProductAsAssignable, markProductAsUnassignable } from './utility'
import { allProductGroupsAtom, allProducts } from 'api/masters.atoms'
import { useProductForId } from 'api/tree.hooks'
import { useWithErrorNotification } from 'shared/ui/GlobalDialog'

export function ProductAssignable({ productId }: { productId: number }) {
  const productsRefresh = useSetAtom(allProducts)
  const productsGroupsRefresh = useSetAtom(allProductGroupsAtom)
  const markAssignable = useWithErrorNotification(
    { errorTitle: 'Error while marking as Assignable' },
    markProductAsAssignable,
  )
  const markUnassignable = useWithErrorNotification(
    { errorTitle: 'Error while marking as Unassignable' },
    markProductAsUnassignable,
  )
  const currentUser = useCurrentUserResource()
  const product = useProductForId(productId)
  const isSuperAdmin = currentUser?.roles_list.includes('super-admin')
  const assignable = !product?.unassignable_at

  const markProduct = async () => {
    if (!isSuperAdmin || !product) return
    if (assignable) {
      // mark as unassignable
      await markUnassignable({ id: product.id })
      await productsGroupsRefresh()
      productsRefresh()
    } else {
      await markAssignable({ id: product.id })
      await productsGroupsRefresh()
      productsRefresh()
    }
  }

  return (
    <Box>
      <Box>
        <span>
          <strong>Assignable:</strong> {assignable ? 'Yes' : 'No'}{' '}
          {isSuperAdmin && (
            <Button onClick={markProduct}>
              {assignable ? 'Set to Unassignable' : 'Set to Assignable'}
            </Button>
          )}
        </span>
      </Box>
      {!assignable && (
        <Box>
          <em>Marked as Unassignable on {product.unassignable_at}</em>
        </Box>
      )}
    </Box>
  )
}
